<script setup lang="ts">
const prefix = 'components.results.filters';

const properties = defineProps<{ loading?: boolean }>();

const durationStore = useDurationFilterStore();
const airportsStore = useAirportsFilterStore();
</script>

<template>
  <ResultsFiltersAccordionWrapper
    :trigger-button-label="$t(`${prefix}.duration`)"
    :has-active-filters="durationStore.hasActiveFilters"
    :loading="properties.loading"
  >
    <ResultsFiltersDuration
      :loading="properties.loading"
      size="s"
    />
  </ResultsFiltersAccordionWrapper>
  <UiCustomSeparatorLine color-class="bg-gray-300" />
  <ResultsFiltersAccordionWrapper
    :trigger-button-label="$t(`${prefix}.airports`)"
    :has-active-filters="airportsStore.hasActiveFilters"
    :loading="properties.loading"
  >
    <ResultsFiltersAirports :loading="properties.loading" />
  </ResultsFiltersAccordionWrapper>
  <UiCustomSeparatorLine color-class="bg-gray-300" />
</template>
